module.exports = __webpack_public_path__ + "media/images/logo-full-vertical-6b0142c7.svg";